import CampaignStrategy from '../components/Coaching/CampaignStrategy'
import Effective from '../components/Coaching/Effective'
import HeroBanner from '../components/Coaching/HeroBanner'
import ListBuilding from '../components/Coaching/ListBuilding'
import Support from '../components/Coaching/Support'
import Technology from '../components/Coaching/Technology'
import Ultimate from '../components/Coaching/Ultimate'
import Header from '../components/Header'
import LandingPageWrapper from '../components/HomePage/LandingPageWrapper'

function Coaching() {
    return (
        <LandingPageWrapper>
            <Header metaTitle={'Coaching | Open Letter Marketing'} />
            <HeroBanner />
            <Ultimate />
            <CampaignStrategy />
            <ListBuilding />
            <Effective />
            <Technology />
            <Support />
        </LandingPageWrapper>
    )
}

export default Coaching
